import("./bootstrap").then(({ mount }) => {
    const localRoot = document.getElementById("onboarding-mfe");

    mount({
        mountPoint: localRoot!,
        routingStrategy: "browser"
    });
});

export {};
